<div>
  <app-modules-shared-top-menu></app-modules-shared-top-menu>
  <div class="content-holder">
    <app-shared-components-spinner [preload]="loader()"></app-shared-components-spinner>
    <div class="content-hld">
      <div class="main-col-hld">
        <div class="main-title">{{ 'translateCurrentStatus' | translate}}</div>
        <div>
          @for (year of groupedArray(); track year.year) {
            <div>
              @for (month of year.data; track month.month) {
                <div class="mb-25">
                  <div class="month-title">{{'translate'+convertNumberToMonth(month.month) | translate}} {{year.year}}</div>
                  @for (step of month.data; track step; let i = $index) {
                    <div class="step-hld">
                      <div>
                        <div class="icon-hld">
                          <mat-icon svgIcon="info"></mat-icon>
                        </div>
                        <div class="vertical-underline"></div>
                      </div>
                      <div class="step-info-hld">
                        <div class="step-title">{{step.title}}</div>
                        <div [id]="'description-' + getDescriptionId(year.year, month.month, i)" class="step-description"
                        [ngClass]="{'expanded': expandedDescriptions()[getDescriptionId(year.year, month.month, i)]}"
                        [innerHTML]="formatDescription(step.description)"></div>
                        @if (overflowingDescriptions().has('description-' + getDescriptionId(year.year, month.month, i))) {
                          <div class="view-more-btn"
                            (click)="toggleDescription(getDescriptionId(year.year, month.month, i))">
                            {{ expandedDescriptions()[getDescriptionId(year.year, month.month, i)] ? 'View less' : 'View more' }}
                          </div>
                        }
                        @let validStepLinks = validLinks(step);
                        @if (validStepLinks.length > 0) {
                          <div class="step-links">
                            @for (link of validStepLinks; track $index; let last = $last) {
                              <a [href]="link.url" target="_blank" rel="noopener noreferrer">{{link.text}}</a>
                              @if (!last) {
                                <span class="step-link-sep"> · </span>
                              }
                            }
                          </div>
                        }
                        <div class="date-hld">{{convertDate(step.date)}}</div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="right-col-hld">
        <div class="illustration-hld status"></div>
      </div>
    </div>
  </div>
</div>
